<template>
    <div class="h-full">
        <mobile-menu :menu="menu" ref="mobileMenu" @go-to="goTo"></mobile-menu>

        <div class="fixed bg-white h-16 text-purple-900 w-full p-3 md:py-4 shadow-lg" style="z-index: 0">
            <div class="container mx-auto flex md:px-20 lg:px-40">
                <div class="md:hidden">
                    <button class="burger-button m-3 mr-5" @click="$refs.mobileMenu?.openMobile()">
                        <span class="burger-bar burger-bar--1"></span>
                        <span class="burger-bar burger-bar--2"></span>
                        <span class="burger-bar burger-bar--3"></span>
                    </button>
                </div>

                <div class="text-2xl pt-1 mr-3 md:hidden flex-1" style="line-height: 1.3">
<!--                    <img style="max-height: 38px" v-if="!actionBar.title" :src="logo">-->

                    <span class="font-light">
                        {{ actionBar.title }}
                    </span>
                </div>

                <div class="block md:hidden pl-8 flex-2" v-if="actionBar.buttons">
                    <button class="text-2xl ml-5 p-1"
                            v-for="(b, i) in actionBar.buttons"
                            @click="execAction(b)" :key="i">
                        <icon :icon="b.icon"></icon>
                    </button>
                </div>

                <div class="hidden md:block text-3xl mr-3 flex">
                    <logo height="48px"></logo>
                </div>

                <div class="hidden md:block p-3 pl-8 flex-1">
                    <div class="">
                        <div>
                            <button
                                    v-for="(item, i) in menu"
                                    @click="goTo(item.link)"
                                    class="mr-8 uppercase" :key="i">
                                {{ $t(item.name) }}
                            </button>

                            <button class="uppercase mr-8" v-if="statusPage" @click="open(statusPage, '_blank')">
                                {{ $t('status') }}
                            </button>
                        </div>
                    </div>

                </div>

                <div class="hidden md:block p-3 pl-8 flex-2">
                    <button class="uppercase" @click="goTo('/clients/my-account')">
                        {{ $t('my_account') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="container md:mx-auto h-full" id="dashContent" ref="dashContent">
            <div class="pt-20 md:pt-24">
                <router-view v-slot="{ Component }" @set-action-bar="setActionBar">
                    <transition :name="transition" mode="out-in">
                        <component :is="Component" />
                    </transition>
                </router-view>
            </div>
        </div>
    </div>

</template>

<style>
    .mobile-menu {
        background-color: rgba(0, 0, 0, 0.4);
    }

    .burger-button {
        width: 25px;
        display: block;
        margin-right: 10px;
    }

    .burger-button span {
        display: block;
        border: 1px solid;
        width: 100%;
        margin-bottom: 5px;
        @apply border-purple-900;
    }
</style>

<script>
    import MobileMenu from "./../components/MobileMenu.vue";
    import Logo from "@/components/Logo.vue";

    export default {
        components: {
            Logo,
            MobileMenu
        },

        mounted() {
            this.startGestureDetector();
        },

        data() {
            return {
                transition: 'fade',
                logo: window.appConfig.dash.logo,
                menu: [
                    {
                        name: 'accounts',
                        link: '/clients'
                    },
                    {
                        name: 'schedules',
                        link: '/clients/schedules'
                    }
                ],
                actionBar: {
                    title: null,
                    buttons: []
                },
                statusPage: window.appConfig.dash.pages.status
            }
        },

        methods: {
            startGestureDetector() {
                let touchstartX = 0;
                let touchendX = 0;

                const gestureZone = this.$refs.dashContent;

                gestureZone.addEventListener('touchstart', (event) => {
                    touchstartX = event.changedTouches[0].screenX;
                }, {
                    passive: true
                });

                gestureZone.addEventListener('touchend', (event) => {
                    touchendX = event.changedTouches[0].screenX;

                    if (touchendX > (touchstartX + 150)) {
                        this.$refs.mobileMenu?.openMobile();
                    }
                }, {
                    passive: true
                });
            },

            onRouteChange() {
                if(this.$route.meta.transition) {
                    this.transition = this.$route.meta.transition;
                } else {
                    this.transition = 'fade';
                }
            },

            goTo(link) {
                if(this.$router.currentRoute.value.path.replace('/', '') !== link.replace('/', '')) {
                    this.actionBar = {
                        title: null,
                        buttons: []
                    };

                    this.$router.push(link);
                }
            },

            open(link) {
                window.open(link, '_blank');
            },

            execAction(action) {
                if(action.link) {
                    this.goTo(action.link);
                }

                if(action.cb) {
                    action.cb();
                }
            },

            setActionBar(e) {
                this.actionBar = e;
            }
        }

    }
</script>